/**
 *
 * @param date a js date object
 * @returns return the date in a dd/mm/yyyy format
 */

const formatDate = (date: Date) =>
  date.toLocaleString("en-GB", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })

export { formatDate }
